export default "__VITE_ASSET__BmRaH626__"